import React from 'react';
import { Badge as DesignSystemBadge, Box, Tooltip } from '@wix/design-system';
import s from '../../sass/badge.module.scss';
export function Badge(props) {
    const { tooltipContent, className, dataHook, showBorder, ...DesignSystemBadgePartialProps } = props;
    const designSystemBadgeProps = {
        dataHook,
        size: 'tiny',
        type: 'solid',
        ...DesignSystemBadgePartialProps,
    };
    return (React.createElement(Box, { dataHook: "tooltip-badge-box", className: s.badgeHeight }, tooltipContent ? (React.createElement(Tooltip, { placement: "right", inline: true, content: tooltipContent, size: "medium" },
        React.createElement(DesignSystemBadge, { className: showBorder ? s.badgeBorder : '', ...designSystemBadgeProps }))) : (React.createElement(DesignSystemBadge, { ...designSystemBadgeProps }))));
}
//# sourceMappingURL=badge.js.map